import Vue from 'vue';
import billTransformer from '../../transformers/bill';
import store from '../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentBill', billTransformer.fetch(data));
  resolve(billTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(billTransformer.fetch(errors));
};

export default (id, params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`/bills/${id}/mark_as_paid`, params)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/markAsPaid.js